import EmailVehicleVisualsHtml        from './vehicle-visuals.email.html';
import VehicleVisualsCatalogHtml      from './templates/vehicle-visuals.catalog.html';
import VehicleVisualsModalCatalogHtml from './templates/vehicle-visuals.modal.catalog.html';
import VehicleVisualsSearchHtml       from './templates/vehicle-visuals.search.html';
import WindowFlipHtml                 from '../../app-lite/core/templates/window-flip.html';

export function VehicleVisuals (
  $uibModal: any,
  $q: any,
  $rootScope: any,
  $translate: any,
  $window: any,
  sessionObjAPI: any,
  workshopAPI: any
) {

  const VehicleVisuals = function () {
    var self = this;

    this.rootUrl     = sessionObjAPI.company().vehicle_visuals_root_url;
    this.interactive = false;
    this.isOpen      = false;
    this.preferences = null;

    this.catalog = {
      loading: true,
      reset  : {
        system () {
          self.catalog.defect = null;
          self.catalog.part   = null;
        },
        part () {
          self.catalog.defect = null;
        },
        defect () {}
      },
      search: {
        query  : '',
        results: []
      }
    };

    this.getUserPreferences();
    this.getCatalog();

    this.tabs = [
      {
        active : true,
        content: VehicleVisualsCatalogHtml,
        title  : $translate.instant('VEHICLE_VISUALS_SPACE.CATALOG')
      },
      {
        active : false,
        content: VehicleVisualsSearchHtml,
        title  : $translate.instant('GENERAL_SPACE.BUTTON.SEARCH')
      }
    ];
  };

  VehicleVisuals.prototype.attachToInspection = function (inspection: any, visual: any) {
    const self = this;

    var params: any = {
      description  : visual.description || visual.description_en_AU,
      inspection_id: inspection.id,
      name         : visual.title || visual.en_AU
    };

    return self.getInteractiveUrl(visual)
    .then((data) => {
      params.url = data.url;

      return workshopAPI.post('/inspection/attach_vehicle_visual', params);
    });
  };

  VehicleVisuals.prototype.attachToInvoice = function (invoice: any, visual: any) {
    const self = this;

    var params: any = {
      description: visual.description || visual.description_en_AU,
      invoice_id : invoice.id,
      name       : visual.title || visual.en_AU
    };

    return self.getInteractiveUrl(visual)
    .then((data) => {
      params.url = data.url;

      return workshopAPI.post('/invoice/attach_vehicle_visual', params);
    });
  };

  VehicleVisuals.prototype.attachToProduct = function () {
    const self = this;

    return $uibModal.open({
      controller       : 'VehicleVisualsModalCtrl',
      templateUrl      : VehicleVisualsModalCatalogHtml,
      windowClass      : 'x-lg-modal flip-container',
      windowTemplateUrl: WindowFlipHtml,
      resolve          : {
        VehicleVisuals: () => self
      }
    }).result;
  };

  VehicleVisuals.prototype.email = function (email: any, visual: any) {
    const self = this;

    return $rootScope.Company.hasIntegration('vehicle-visuals') ?
      self.getCustomerUrl(visual)
      .then((url) => {
        return $uibModal.open({
          controller : 'EmailVehicleVisualsCtrl',
          templateUrl: EmailVehicleVisualsHtml,
          windowClass: 'lg-modal',
          resolve    : {
            email : () => email,
            url   : () => url,
            visual: () => visual
          }
        }).result;
      }) :
      workshopAPI.get('/vehicle_visuals/upgrade_url')
      .then((url) => {
        $window.open(url, '_blank');

        return Promise.resolve(true);
      });
  };

  VehicleVisuals.prototype.getCatalog = function () {
    const self = this;

    return workshopAPI.get('/vehicle_visuals/get_animation_details', !!self.interactive)
    .then((catalog) => {
      self.catalog.data    = catalog;
      self.catalog.loading = false;

      return catalog;
    });
  };

  VehicleVisuals.prototype.getUserPreferences = function () {
    const self = this;

    workshopAPI.get('/vehicle_visuals/get_user_preferences')
    .then((preferences) => {
      self.preferences     = preferences.data;
      self.catalog.loading = false;

      return preferences;
    });
  };

  VehicleVisuals.prototype.getCustomerUrl = function (visual: any) {
    return workshopAPI.get('/vehicle_visuals/get_dynamic_generated_url', visual.part_id);
  };

  VehicleVisuals.prototype.getInteractiveUrl = function (visual: any) {
    const self = this;

    return workshopAPI.get('/vehicle_visuals/interactive_animations', [ visual.part_id, (self.interactive ? 1 : 0) ]);
  };

  VehicleVisuals.prototype.getRootUrl = function (visual: any) {
    const self = this;

    return Promise.resolve(`${self.rootUrl}&part_id=${visual.part_id}&is_interactive=${self.interactive ? 1 : 0}`);
  };

  VehicleVisuals.prototype.hasNoChildren = function (object: any) {
    if (object === null) {
      return true;
    }

    for (var key in object) {
      if (Object.prototype.hasOwnProperty.call(object, key)) {
        return false;
      };
    }

    return true;
  };

  VehicleVisuals.prototype.isSelected = function (id: any, type: any) {
    const self = this;

    return self.catalog[type] ? id === self.catalog[type].part_id : false;
  };

  VehicleVisuals.prototype.search = function () {
    const self = this;

    self.catalog.search.results = [];

    return workshopAPI.get('/vehicle_visuals/search_animations', encodeURI(self.catalog.search.query))
    .then((parts) => {
      parts.forEach((part) => {
        self.catalog.search.results.push(part);
      });

      return Promise.resolve(true);
    });
  };

  VehicleVisuals.prototype.select = function (type: any, obj: any) {
    const self = this;

    if (self.catalog[type] && self.catalog[type].part_id === obj.part_id) {
      self.catalog[type]   = null;
      self.catalog.part_id = null;
    } else {
      self.catalog[type] = obj;
      self.catalog.part_id = obj.part_id;
    }

    self.catalog.reset[type]();
  };

  return VehicleVisuals;
}

import { forwardRef, Inject, Injectable } from '@angular/core';
import { LegacyUibModalService } from '../../app-lite/modals/legacy-uib-modal.service';
import { TranslateService } from '@ngx-translate/core';
import { ApiService }       from '../../app-lite/api/api.service';
import { CompanyService }   from '../../app-lite/companies/company.service';
import { SessionService }   from '../../app-lite/sessions/session.service';

@Injectable({ providedIn: 'root' })
export class VehicleVisualsFactory {
  private VehicleVisualsConstructor: any;

  constructor (
    private modalService: LegacyUibModalService,
    private translateService: TranslateService,
    @Inject(forwardRef(() => SessionService)) private sessionService: SessionService,
    @Inject(forwardRef(() => ApiService)) private apiService: ApiService,
    @Inject(forwardRef(() => CompanyService)) private companyService: CompanyService
  ) {
    const $rootScope = {
      Company: this.companyService
    };

    this.VehicleVisualsConstructor = VehicleVisuals(
      this.modalService, null, $rootScope, this.translateService,
      window, this.sessionService, this.apiService
    );
  }

  create () : any {
    return new this.VehicleVisualsConstructor();
  }
}